import { useAuth0 } from "@auth0/auth0-react";
import { useCallback, useEffect } from "react";
import Mixpanel from "../utils/mixpanel";

export interface useGetValidAccessTokenReturnType {
  getValidAccessToken: () => Promise<string>;
}

const useGetValidAccessToken = (): useGetValidAccessTokenReturnType => {
  const { getAccessTokenSilently, logout, user } = useAuth0();

  const getValidAccessToken = useCallback(async () => {
    try {
      const accessToken = await getAccessTokenSilently();
      const decodedToken = JSON.parse(atob(accessToken.split(".")[1]));
      const expiryTime = decodedToken.exp * 1000;
      if (expiryTime >= Date.now()) {
        return accessToken;
      } else {
        logout({ logoutParams: { returnTo: window.location.origin } });
        sessionStorage.clear();
        Mixpanel.reset();
        return "";
      }
    } catch (error) {
      const isPublicPage = window.location.pathname.includes("explore") || window.location.pathname.includes("share");
      if (!isPublicPage) {
        console.error("Error fetching access token:", error);
        logout({ logoutParams: { returnTo: window.location.origin } });
        sessionStorage.clear();
        Mixpanel.reset();
      }
      return "";
    }
  }, [logout, getAccessTokenSilently]);

  useEffect(() => {
    if (user) getValidAccessToken();
  }, [user, getValidAccessToken]);

  return { getValidAccessToken };
};

export default useGetValidAccessToken;
